"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Button } from "@nxt-costco-com/forge-components";
import { SwatchIcon } from "../SwatchIcon/index.js";
import { SWATCH_BUTTON_TEST_ID_PREFIX } from "../constants.js";
import { ButtonContainerOutOfStockStyles, ButtonContainerSelectedStyles, ButtonContainerCompactStyles, ButtonContainerStyles, swatchStyles } from "./styles.js";
const SwatchButton = forwardRef((props, ref) => {
  const {
    onFocus,
    onClick,
    onBlur,
    onMouseEnter,
    onMouseLeave,
    outOfStockText,
    productSwatch,
    selected,
    variant = "full",
    ariaDescribedBy,
    swatchButtonSx = {}
  } = props;
  const mergedButtonContainerStyles = {
    ...ButtonContainerStyles,
    ...swatchButtonSx,
    ...variant === "compact" ? ButtonContainerCompactStyles : {},
    ...productSwatch.isOutOfStock ? ButtonContainerOutOfStockStyles : {},
    ...selected ? ButtonContainerSelectedStyles : {}
  };
  const swatchTestId = SWATCH_BUTTON_TEST_ID_PREFIX + productSwatch.attributeValue.replace(/\s+/g, "");
  const swatchLabel = (productSwatch == null ? void 0 : productSwatch.isOutOfStock) ? `${productSwatch == null ? void 0 : productSwatch.attributeValue}, ${outOfStockText}` : productSwatch == null ? void 0 : productSwatch.attributeValue;
  return /* @__PURE__ */ jsx(
    Button,
    {
      "aria-describedby": ariaDescribedBy,
      "aria-label": swatchLabel,
      "aria-pressed": selected,
      "data-testid": swatchTestId,
      onBlur,
      onClick,
      onFocus,
      onMouseEnter: () => onMouseEnter == null ? void 0 : onMouseEnter(productSwatch),
      onMouseLeave,
      selected,
      sx: mergedButtonContainerStyles,
      value: productSwatch.id,
      ref,
      disableRipple: true,
      children: /* @__PURE__ */ jsx(
        SwatchIcon,
        {
          productSwatch,
          sx: swatchStyles,
          variant
        }
      )
    }
  );
});
SwatchButton.displayName = "SwatchButton";
export {
  SwatchButton
};
